import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ReviewAggregationForTagResponse } from '@models/tag/reviewAggregationForTagResponse';
import { Tag } from '@models/tag/tag.model';
import { TagCat } from '@models/tag/tagCat.model';

import { environment } from '../../../environments/environment';

interface LatestReviews {
  region?: string;
  city?: string;
  keywords: any;
  tagId: number;
}
@Injectable()
export class TagService {
  baseHref = `${environment.apiUrl}/tag`;

  constructor(private http: HttpClient) {}

  deleteTagByIdForUser(tagId: number): Observable<any> {
    const url = `${this.baseHref}/delete-tag/${tagId}`;
    return this.http.delete<any>(url);
  }

  ensureTagsOnUser(tagData): Observable<any> {
    const url = `${this.baseHref}/ensure-tags-user`;
    return this.http.post<any>(url, tagData);
  }

  getTagsForUser(userId: number): Observable<Tag[]> {
    if (!userId || !Number.isInteger(userId)) {
      throw new Error('Invalid user id provided');
    }
    const url = `${this.baseHref}/get-tags-user/${userId}`;
    return this.http.get<Tag[]>(url);
  }

  getAllTags(): Observable<any[]> {
    const url = `${this.baseHref}/get-all-tags`;
    return this.http.get<any[]>(url);
  }

  totalReviewsForTasksTag(
    tagId: number,
  ): Observable<ReviewAggregationForTagResponse> {
    if (!tagId || !Number.isInteger(tagId)) {
      throw new Error('Invalid tag id provided');
    }
    const url = `${this.baseHref}/review-count-tag/${tagId}`;
    return this.http.get<ReviewAggregationForTagResponse>(url);
  }

  getAllCategories(): Observable<TagCat[]> {
    const url = `${this.baseHref}/all-cats`;
    return this.http.get<TagCat[]>(url);
  }

  tagPrediction(data: { Task: string }): Observable<string[]> {
    const url = `${this.baseHref}/tag-prediction`;
    return this.http.post<any>(url, data);
  }

  getLatestReviews(data: LatestReviews): Observable<any> {
    const url = `${this.baseHref}/latest-reviews-vertical`;
    return this.http.post<any>(url, data);
  }

  getWithSlug(tagSlug: string): Observable<Tag> {
    const url = `${this.baseHref}/by-slug/${tagSlug}`;
    return this.http.get<any>(url);
  }

  getTagsByTask(taskId: number): Observable<any[]> {
    const url = `${this.baseHref}/tasks-tags/${taskId}`;
    return this.http.get<any[]>(url);
  }

  getTagTree(): Observable<TagCat[]> {
    const url = `${this.baseHref}/all-cats-tree`;
    return this.http.get<TagCat[]>(url);
  }

  updateTagsOnUser(tagData): Observable<any> {
    const url = `${this.baseHref}/update-user-tags`;
    return this.http.post<any>(url, tagData);
  }

  updateTagsWithTagCatIds(tagCatIds: number[]) {
    const url = `${this.baseHref}/add-tags-from-cats`;
    return this.http.post(url, { tagCatIds });
  }
}
